import { get } from 'jquery';
import { connect } from 'react-redux';

import {
  clearOfficeCreatedUpdated,
  getItemSummary,
  getOfficeDetails,
  setOfficeDetails,
} from '../officesActions';
import OfficeDetails from './OfficeDetails';

// Store props to map with current state
const mapStateToProps = state => ({
  officeDetails: state.office.officeDetails,
  isDetailsLoading : state.office.isDetailsLoading,
  itemSummary: state.office.itemSummary,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOfficeDetails: params => dispatch(getOfficeDetails(params)),
  getItemSummary: params => dispatch(getItemSummary(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(OfficeDetails);
